
export default {
  name: 'IconCopy',
}
